import { TOKEN_EXPIRY_BUFFER } from "@components/AuthorizationContext";
import { jwtDecode } from "jwt-decode";

export function decodeToken<T = object>(token: string): T | null {
    try {
        if (token.split('.').length !== 3 || typeof token !== 'string') {
            return null;
        }
        const payload: string = token.split('.')[1];
        const decoded = JSON.parse(Buffer.from(payload, 'base64').toString())
        return decoded;
    } catch (error) {
        console.error(error)
        return null;
    }
}
export function isTokenExpired(token: string): boolean {
    const decodedToken: any = decodeToken(token);
    let result: boolean = true;
    if (decodedToken?.exp) {
        const expirationDate: Date = new Date(0);
        expirationDate.setUTCSeconds(decodedToken.exp);
        result = expirationDate.valueOf() < new Date().valueOf();

        if (result) {
            console.info(`Token is expired`);
        }
    }

    return result;
}

export function isTokenNearlyExpired(token: string): boolean {
    try {
        const { exp: expirationTime } = jwtDecode<{ exp: number }>(token);
        const currentTime = Math.floor(Date.now() / 1000);

        if ((expirationTime - currentTime) <= TOKEN_EXPIRY_BUFFER) {
            console.info(`Token will be expired in less than ${TOKEN_EXPIRY_BUFFER} seconds`);
            return true;
        }
        return false;
    } catch {
        return true;
    }
}
